import axiosInstance from './axios-instance'

export class ApiBase {
  constructor({ resource, name, successPath }) {
    this.resource = resource
    this.name = name
    this.successPath = successPath
    this.api = axiosInstance
  }

  /**
   * @param {Object} params
   * @param {string} params.q
   * @params{Integer} params.perPage
   */
  index({ q, page = '', perPage, order = {} }) {
    const params = {}

    if (q) {
      params.q = q
    }

    if (page) {
      params.page = page
    }

    if (perPage) params.per_page = perPage

    if (Object.keys(order).length > 0) {
      params['order[field]'] = order?.field
      params['order[sort]'] = order?.sort
    }

    return this.api.get(
      `${this.resource}?` + new URLSearchParams(params).toString()
    )
  }

  /**
   * @param {Object} params
   * @param {integer} params.id
   */
  show({ id }) {
    return this.api.get(`${this.resource}/${id}`)
  }

  /**
   * @param {Object} params
   * @param {Object} params.body
   */
  create({ body }) {
    return this.api.post(`${this.resource}`, body)
  }

  /**
   * @param {Object} params
   * @param {integer} params.id
   * @param {Object} params.body
   */
  update({ id, body }) {
    return this.api.put(`${this.resource}/${id}`, body)
  }
}
